import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ItemHdrQueryCriteriaClass, ItemHdrCriteriaModelQuery } from '../../../criteria/item-hdr-criteria.model';
import { ApiResponseModel, BasicApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ItemSearchContainerModel } from '../../../../../../models/aggregates/item-search/item-search-container.model';

@Injectable({
  providedIn: 'root'
})
export class ItemSearchService extends BaseApiTemplateService<ItemSearchContainerModel> {

  readonly url = Core2Config.T2T_DOMAIN_URL_PREFIX + Core2Config.CONFIG_PREFIX + 'fi-item-linking/login-guest-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.T2T_DOMAIN_URL_PREFIX + Core2Config.CONFIG_PREFIX + 'fi-item-linking/login-guest-ep';
    this.endpoint_path = Core2Config.T2T_DOMAIN_URL_PREFIX + Core2Config.CONFIG_PREFIX + 'fi-item-linking/login-guest-ep';
    this.httpClient = http;
  }

  getItem(otherTenantCode: string, query: string, visa: ApiVisa): Observable<ApiResponseModel<ItemSearchContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + otherTenantCode + '/fi-items/search?' + query;
    }
    return this.httpClient.get<ApiResponseModel<ItemSearchContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }
}